import React from 'react';
import { Widget } from '@typeform/embed-react';

export const TypeformSurvey: React.FC = () => {
  return (
    <Widget 
      id="jubx8aqp"
      style={{ width: '100%', height: '500px' }}
      className="my-form"
    />
  );
}; 